export default __webpack_public_path__ + "static/media/optimistic_ethereum.cebb89d4.svg";